<template>
  <div class="page-container">
    <div class="query-title">终端直配要货单查询</div>

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <template #totalNum>
            <div class="totalNum" v-if="totalAllCount.wantTotal">要货总计:{{totalAllCount.wantTotal}}件</div>
            <div class="totalNum" v-if="totalAllCount.finishTotal">已完成总计:{{totalAllCount.finishTotal}}件</div>
            <div class="totalNum" v-if="totalAllCount.cancelTotal">已取消总计:{{totalAllCount.cancelTotal}}件</div>
          </template>
          <template #button>
            <table-button name="export" tip="导出" @click="exportExcel('发货单报表')" />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
            @cell-dblclick="cellClick"
          >
            
            <template #handleNode="{ row }">
              <span>{{ row.billStatus == 'E003' ? row.billStatusTextView : row.handleNode}}</span>
            </template>
            <template #qaz="{ row }">
              <a :class="row.orderStatusTextView == '已回单' ? 'blue' : ''" @click="showImages(row)">{{ row.orderStatusTextView == '已回单' ? '查看' : '' }}</a>
              <!-- <span class="blue" @click="showWantGoodsApply(row.id,row.billStatus,row.createdByName,row)">查看</span> -->
            </template>
            <template #orderStatusTextView="{ row }">
              <span>{{ row.orderStatusTextView || '未发运'}}</span>
            </template>
            <template #wantCode="{ row }">
              <span class="blue" @click="showWantGoodsApply(row.id,row.billStatus,row.createdByName,row)">{{ row.wantCode }}</span>
            </template>
            <template #isShunt="{row}">
              <span>{{ row.isShunt == 1 ? '是' : '否' }}</span>
            </template>
            <template #isPcj="{row}">
              <el-checkbox v-model="row.isPcj" disabled size="mini" :true-label="1" :false-label="0" />
            </template>
            <template #ajResult="{row}">
              <span v-if="row.billStatus === 'E003'">
                <el-link v-if="row.ajResult == 1" size="mini" type="success">{{ row.ajResultTextView }}</el-link>
                <el-link v-else-if="row.ajResult == 0" size="mini" type="error">{{ row.ajResultTextView }}</el-link>
                <el-link v-else-if="row.ajResult == 2" size="mini" type="success">{{ row.ajResultTextView }}</el-link>
              </span>
            </template>
          </vxe-grid>
        </Table-filter>
      </div>
    </div>

    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />

    <el-dialog
      v-dialogDrag
      :visible.sync="trackingDialog"
      title="跟踪物流"
    >
      <el-timeline :reverse="false">
        <el-timeline-item
          v-for="(activity, index) in activities"
          :key="index"
          :timestamp="activity.nodeTime"
        >
          {{ activity.nodeStatus }}
        </el-timeline-item>
      </el-timeline>
    </el-dialog>
  </div>
</template>

<script>
import { findWantGoodsList, apiAgainSendData, apiWantGoodsLogistics, apiExportExcelWantGoodsTerminalDatas, apiFindAnJiOrderStatus, statInfo } from '@/api/applyForGoods/index'
import tableMixins from '@/utils/tableMixins'
import pageConfig, { pageSearch } from './config/childCustomerList'

import { getToken } from '@/utils/auth'
import { DOWNLOAD_API } from '@/api/baseUrl'
import { mapGetters } from 'vuex'
export default {
  mixins: [tableMixins],
  data() {
    return {
      loading: false,
      trackingDialog: false,
      activities: [{
        nodeStatus: '装车',
        nodeTime: '2021-07-21 9:00'
      }, {
        nodeStatus: '起运',
        nodeTime: '2021-07-23 9:00'
      }, {
        nodeStatus: '到达宣化中转仓',
        nodeTime: '2021-07-25 9:00'
      }],
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        buttons: [
          {
            label: '取消要货单',
            style: 'primary',
            icon: 'cancle',
            position: 'all',
            scope: null,
            type: 'custom',
            code: 'cancelWantGoods',
            enabledCustom: 'N',
            dialog: '',
            custom: { link_condition: [], link_linkage: [] }
          },
          {
            label: '物流跟踪',
            style: 'primary',
            icon: 'export',
            position: 'all',
            scope: null,
            type: 'custom',
            code: 'tracking',
            enabledCustom: 'N',
            dialog: '',
            custom: { link_condition: [], link_linkage: [] }
          },
          {
            label: '重传数据',
            style: 'primary',
            icon: 'cancle',
            position: 'all',
            scope: null,
            type: 'custom',
            code: 'againSendData',
            enabledCustom: 'N',
            dialog: '',
            custom: { link_condition: [], link_linkage: [] }
          }
          /* {
            label: '关闭',
            style: 'primary',
            icon: 'export',
            position: 'all',
            scope: null,
            type: 'custom',
            code: 'tracking2',
            enabledCustom: 'N',
            dialog: '',
            custom: { link_condition: [], link_linkage: [] }
          }*/
        ],
        columns: [
          { type: 'checkbox', title: '', width: 50, field: 'checkbox' }
        ],
        data: []
      },
      pageSearch,
      searchField: {},
      isSetFilter: false,
      totalNum: 0,
      totalAllCount: {}
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created() {
    this.initPage(pageConfig)
    this.tableSort.push({ field_name: 'createdDate', field_sort: 'X' })
  },
  methods: {
    async showImages(row) {
      const { data } = await apiFindAnJiOrderStatus({ wantCode: row.wantCode })
      if (data.length === 0) {
        return this.$message.error('没有图片！')
      }
      data.forEach(item => {
        const viewers = item.originalDrawing.split(',')
        viewers.forEach(ele => {
          window.open(ele, '_blank');
        });
      })
    },
    cellClick({ row, rowIndex, column }) {
      const $table = this.$refs.xTable
      $table.setCheckboxRow(row, true)
    },
    async exportPage() {
      frontExport(this.gridOptions.columns, this.gridOptions.data, '要货单')
    },

    tableEvent(code) {
      switch (code) {
        case 'cancelWantGoods':
          this.cancelWantGoods()
          break
        case 'tracking':
          this.showTracking()
          break
        case 'againSendData':
          this.againSendData()
          break
      }
    },
    showTracking() {
      const checkeData = this.$refs.xTable.getCheckboxRecords()
      if (checkeData.length === 0) {
        return this.$message.error('请选择一条数据！')
      } else if (checkeData.length > 1) {
        return this.$message.error('请选择一条数据！')
      }
      apiWantGoodsLogistics({ faHuoCode: checkeData[0].faHuoCode }).then(res => {
        const { data, status } = res
        if ((status - 0) === 1) {
          this.activities = data[0].nodes
          this.trackingDialog = true
        }
      })
    },
    showWantGoodsApply(id, status, createdByName, row) {
      const isSearchPage = '1'

      if (status === 'E001' && this.userInfo.name === createdByName) {
        // isSearchPage = '0'
        this.$router.push({
          // path: '/wly/to-goods/to-goods-apply-edit',
          path: '/wly/to-goods/business-processing/deliver-apply',
          query: {
            id,
            isSearchPage: isSearchPage,
            active: 'toGoods'
          }
        })
      } else {
        this.$router.push({
          path: '/wly/to-goods/data-searching/delivery-search-detail',
          query: {
            id,
            isSearchPage: isSearchPage
          }
        })
      }
    },
    async againSendData() {
      const checkeData = this.$refs.xTable.getCheckboxRecords()
      // console.log('checkeData========',checkeData)

      if (checkeData.length === 0) {
        return this.$message.error('请选择一条数据！')
      }

      let flag = 0; let flag2 = 0
      checkeData.forEach(item => {
        // alert(item.billStatus)
        // alert(item.ajResult)
        if (item.ajResult === 1) {
          flag = 1
        }
        if (item.billStatus != 'E003') {
          flag2 = 1
        }
      })
      if (flag === 1) {
        return this.$message.error('请选择安吉返回状态为异常的数据！')
      }
      if (flag2 === 1) {
        return this.$message.error('只能推送已审批的数据！')
      }
      try {
        this.$confirm('是否真的要重传数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async() => {
          const res = await apiAgainSendData(checkeData)
          if (res.data.status === 1) {
            this.$message.success('重传成功！')
          }
        })
      } catch (error) {
        //
      }
    },
    async cancelWantGoods() {
      const checkeData = this.$refs.xTable.getCheckboxRecords()
      if (checkeData.length === 0) {
        return this.$message.error('请选择一条数据！')
      } else if (checkeData.length > 1) {
        return this.$message.error('请选择一条数据！')
      }
      const { status, billStatus, ajResult } = checkeData[0]
      if (billStatus === 'E003' && ajResult == 2) {
        return this.$message.warning('未推送到安吉，不能取消！')
      }
      if (status === 3 && billStatus !== 'E005') {
        this.$router.push({
          path: '/wly/to-goods/business-processing/cancel-to-goods',
          query: {
            orderNo: checkeData[0].wantCode,
            orderId: checkeData[0].id,
            customerCode: checkeData[0].customerCode,
            customerName: checkeData[0].customerName
          }
        })
      } else {
        this.$message.warning('该条数据不能取消！')
      }
    },
    // 当前日期
    getCurrentDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    // 本周一日期
    getMondayOfCurrentWeek() {
      const today = new Date();
      const day = today.getDay(); // 0是周日，1是周一，...，6是周六
      const diff = today.getDate() - day + (day === 0 ? -6 : 1); // 调整周日的情况
      const monday = new Date(today.setDate(diff));
      
      const year = monday.getFullYear();
      const month = String(monday.getMonth() + 1).padStart(2, '0');
      const dayOfMonth = String(monday.getDate()).padStart(2, '0');
      return `${year}-${month}-${dayOfMonth}`;
    },
    // 当月第一天日期
    getFirstDayOfCurrentMonth() {
      const today = new Date();
      const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      const year = firstDay.getFullYear();
      const month = String(firstDay.getMonth() + 1).padStart(2, '0');
      const day = String(firstDay.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    async getStatInfo(params) {
      const res = await statInfo(params)
      this.totalAllCount = {...res.data}
    },
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        ...this.allConditions,
        wantCode: [{ sign: 'I', option: 'CP', low: 'FHZ*', high: '' }],
        ...this.pagination,
        is_result: 1,
        sort: this.sortData.concat(this.tableSort),
        demandType:[{"sign":"I","option":"EQ","low":"ZDZG","high":""}]
      }
      // 月2 周1
      if(params.cycleDate){
        if(params.cycleDate[0]?.low == '1'){
          params.createdDate = [{"sign":"I","option":"BT","low":this.getMondayOfCurrentWeek(),"high":this.getCurrentDate()}]
          delete params.cycleDate
        }else{
          params.createdDate = [{"sign":"I","option":"BT","low":this.getFirstDayOfCurrentMonth(),"high":this.getCurrentDate()}]
          delete params.cycleDate
        }
      }
      this.loading = true
      try {
        const { data: { Rows, Total }, calculation, field } = await findWantGoodsList(params)
        if (Rows.length === 0 && Total) {
          this.queryData(1, ranges)
          return
        }
        Total && this.getStatInfo(params)
        this.pagination.totalCount = Total - 0
        this.calculation = this.filtercalculation(calculation, 'xTable', true)
        // 显示总计
        calculation.forEach(item => {
          if (item.field_name === 'wantQuantity') {
            this.totalNum = item.field_data.sum
          }
        })
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(Rows)
        } else {
          this.gridOptions.data = Rows.concat(this.tableCountData)
        }
        this.allOptions = this.filterAllOptions(field, 'xTable', true)
        this.setFilter('xTable', (field, options) => {
          if (field === 'isPcj' || field === 'isShunt') {
            options.forEach(item => {
              if (item.value == '0') {
                item.label = '否'
              } else if (item.value == '1') {
                item.label = '是'
              }
            })
          }
          if (field === 'ajResult') {
            options.forEach(item => {
              if (item.value == 0) {
                item.label = '推送失败'
              } else if (item.value == 1) {
                item.label = '推送成功'
              } else if (item.value == 2) {
                item.label = '推送中'
              }
            })
          }
        })
      } catch (e) {
        //
      }
      this.loading = false
    },
    // 导出全部 导出本页
    async exportExcel(fileName) {
      const params = {
        templateCode: 'wantGoodsTerminal',
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        ...this.allConditions,
        wantCode: [{ sign: 'I', option: 'CP', low: 'FHZ*', high: '' }],
        demandType:[{"sign":"I","option":"EQ","low":"ZDZG","high":""}]
      }

      const res = await apiExportExcelWantGoodsTerminalDatas(params)

      if (res?.status !== 0) {
        return
      }

      const url = `${DOWNLOAD_API()}/attachment/downFileByTmpdir.ajax?file=${
        res.data.file
      }&authToken=${getToken()}&fileName=${fileName}`
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      // link.target = '_blank'
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    }
  }
}
</script>

<style scoped>
.blue {
    color: rgb(45, 146, 214);
    cursor: pointer;
  }
  .totalNum {
    display: flex;
    align-items: center;
    color: #333;
    font-size: 14px;
    margin-left: 6px;
    font-weight: 700;
  }
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/data-searching/childCustomerList.vue